<template>
  <v-container>
    <v-card>
      <v-card-title>
        List of the Owners
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          solo-inverted
          v-model="search"
          append-icon="fas fa-search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :no-data-text="noData"
          :loading="isLoading"
          :headers="headers"
          :items="Owners"
          :search="search"
        >
          <template v-slot:item.blc="{ item }">
            <ShowBalance
              :ReqURL="`${BaseURL}/balance`"
              :Title="item.FullName"
              :query="{ _id: item._id }"
            >
            </ShowBalance>
          </template>
          <template v-slot:item.tran="{ item }">
            <!-- <OwnerTransaction :OwnerInfo="item"></OwnerTransaction> -->
            <OwnerTransaction
              :BaseURL="BaseURL"
              :Title="item.FullName"
              :TranInfo="item"
            >
              <template v-slot:deposit="{ row }">
                <template v-if="row.Acc == 'Cr'">
                  {{ Math.abs(row.Amount).toLocaleString() }}
                  {{ row.AmountType | MoneySigns }}
                </template>
                <p v-else></p>
              </template>
              <template v-slot:withdraw="{ row }">
                <template v-if="row.Acc == 'Dr'">
                  {{ Math.abs(row.Amount).toLocaleString() }}
                  {{ row.AmountType | MoneySigns }}
                </template>
                <p v-else>--------</p>
              </template>
            </OwnerTransaction>
          </template>

          <template v-slot:item.more="{ item }">
            <v-btn
              small
              icon
              color="white"
              :to="{ name: 'OwnerInfo', params: { CustomerID: item } }"
            >
              <v-icon color="error" right>
                fas fa-user-cog
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <!-- <p>{{ fab }}</p> -->
        <OwnerAdd :loadFunction="loadAllOwners"></OwnerAdd>
        <!-- <v-speed-dial bottom left absolute direction="right" v-model="fab">
          <template v-slot:activator>
            <v-btn :color="fab ? 'red' : 'blue'" dark fab>
              <v-icon v-if="fab">fas fa-times</v-icon>
              <v-icon v-else>fas fa-user-circle</v-icon>
            </v-btn>
          </template>
          <template #default>
            <OwnerAdd
              @click="fab = false"
              :loadFunction="loadAllOwners"
            ></OwnerAdd>
          </template>
        </v-speed-dial> -->
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
    OwnerAdd: () => import("@/components/HQ/Owner/NewOwner.vue"),
    // OwnerTransaction: () => import("@/components/HQ/Owner/OwnerTran.vue"),
    OwnerTransaction: () => import("@/components/util/TranSactionView.vue"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
  },
  data() {
    return {
      BaseURL: "/owner",
      noData: "No Owner is availble",
      fab: false,
      isLoading: true,
      search: "",
      headers: [
        {
          text: "Full Name",
          align: "left",
          value: "FullName",
        },
        { text: "Phone", value: "Cusphone" },
        {
          text: this.$vuetify.breakpoint.name == "xs" ? undefined : "Reg Date",
          value: this.$vuetify.breakpoint.name == "xs" ? undefined : "RegDate",
        },
        { text: "ID Number", value: "IDNomber", sortable: false },
        { text: "Balance", value: "blc", align: "center", sortable: false },
        { text: "Tran", value: "tran", align: "center", sortable: false },
        {
          text: "More",
          value: "more",
          align: "center",
          sortable: false,
        },
      ],
      Owners: [],
    };
  },
  computed: {
    // TotalShares() {
    //   return this.Owners.reduce((total, val) => {
    //     return (total += val.share);
    //   }, 0);
    // }
  },
  methods: {
    loadAllOwners() {
      this.$store
        .dispatch("GET_ONLY", this.BaseURL)
        .then(result => {
          // console.log(result);
          this.Owners = result.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.loadAllOwners();
  },
};
</script>
<style scoped>
.hosdhig {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
